import { c as _c } from "react/compiler-runtime";
import type { ItemOrientation } from "@sticker-giant/sg-frontend-common";
import { trackOrientationSelected } from "@/lib/analytics/segment";
import { useProduct } from "@/queries/useProduct";
import { usePdpStore } from "@/stores/usePdpStore";
import OptionRadioField from "./OptionRadioField";
import { useProductBuilderContext } from "./ProductBuilderContext";
import { useProductMicrocopy } from "./useProductMicrocopy";
import { useFieldErrorId } from "./ValidationError";
export default function RollFinishing() {
  const $ = _c(15);
  const {
    product
  } = useProductBuilderContext();
  const {
    data: productAdmin
  } = useProduct(product.sku);
  const selectedFinish = usePdpStore(_temp);
  const selectedOrientation = usePdpStore(_temp2);
  const selectOrientation = usePdpStore(_temp3);
  const clearValidationError = usePdpStore(_temp4);
  const orientationErrorId = useFieldErrorId("orientation");
  const rollFinishingControlIdBase = `roll-finishing-${product.sku}`;
  const rollFinishingLabelId = `${rollFinishingControlIdBase}-label`;
  const rollFinishingHelpDialogId = `${rollFinishingControlIdBase}-help-dialog`;
  const microcopyFields = useProductMicrocopy();
  const rollFinishingHelper = microcopyFields?.rollFinishingHelper;
  const rollFinishingLabel = microcopyFields?.rollFinishingLabel ?? "Roll Finishing";
  const orientationValue = selectedOrientation ?? productAdmin?.defaultOrientation;
  const finishValue = selectedFinish ?? productAdmin?.defaultFinishing;
  const selectedFinishOption = productAdmin?.finishingOptions.find(option => option.sku === finishValue);
  const allowsOrientation = !!selectedFinishOption?.allowsOrientation;
  if (!allowsOrientation || (productAdmin?.orientationOptions.length ?? 0) <= 1) {
    return null;
  }
  let t0;
  if ($[0] !== clearValidationError || $[1] !== selectOrientation) {
    t0 = value => {
      const orientation = value as ItemOrientation;
      selectOrientation(orientation);
      clearValidationError("orientation");
      trackOrientationSelected(orientation);
    };
    $[0] = clearValidationError;
    $[1] = selectOrientation;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== productAdmin?.orientationOptions) {
    t1 = productAdmin?.orientationOptions ?? [];
    $[3] = productAdmin?.orientationOptions;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== orientationErrorId || $[6] !== orientationValue || $[7] !== rollFinishingControlIdBase || $[8] !== rollFinishingHelpDialogId || $[9] !== rollFinishingHelper || $[10] !== rollFinishingLabel || $[11] !== rollFinishingLabelId || $[12] !== t0 || $[13] !== t1) {
    t2 = <OptionRadioField field="orientation" label={rollFinishingLabel} helper={rollFinishingHelper} controlIdBase={rollFinishingControlIdBase} labelId={rollFinishingLabelId} helpDialogId={rollFinishingHelpDialogId} errorId={orientationErrorId} value={orientationValue} onValueChange={t0} options={t1} />;
    $[5] = orientationErrorId;
    $[6] = orientationValue;
    $[7] = rollFinishingControlIdBase;
    $[8] = rollFinishingHelpDialogId;
    $[9] = rollFinishingHelper;
    $[10] = rollFinishingLabel;
    $[11] = rollFinishingLabelId;
    $[12] = t0;
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
}
function _temp4(state_2) {
  return state_2.clearValidationError;
}
function _temp3(state_1) {
  return state_1.selectOrientation;
}
function _temp2(state_0) {
  return state_0.orientation;
}
function _temp(state) {
  return state.finish;
}